import { DomainError } from '../../domain/shared/DomainError';

export class SecureRandomUnavailableError extends DomainError {
  public constructor() {
    super(
      'secure_random_unavailable',
      'La source cryptographique nécessaire à la préparation locale est indisponible.',
    );
    this.name = 'SecureRandomUnavailableError';
  }
}
